import { type GetHookResponse } from '../hooks'
import { useTantalimQuery } from '../query'
import { conversationKey } from './keys'
import {
  type ConversationGetInput,
  type ConversationGetSuccess,
  type ConversationData,
  type ConversationId,
} from '@terros/common'

export function useConversation(conversationId: ConversationId): GetHookResponse<ConversationData> {
  return useTantalimQuery<ConversationGetInput, ConversationGetSuccess, ConversationData>({
    url: '/conversation/get',
    queryKey: conversationKey(conversationId),
    input: {
      conversationId,
    },
    convertResponse: (data) => data.conversation,
  })
}
